import axios from "axios";

export const getUserGridService = (query: any) => {
    return axios.get(`api/Users/manage?${`$count=true&`}${query}`);
};


export const getUserExcelService = (query: any) => {
    const url = `api/Users/excel?${`$count=true&`}${query}&$orderby=modifiedDate desc`;
    return axios.get(url);
};
